import React, { useEffect, useState } from "react";
import "./UpdateNew.scss";
import SideBar from "../../../../Components/SideBar/SideBar";
import Header from "../../../../Components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { getNewById, UpdateNewApi } from "../../../../api/newsApi/New.js";
import { useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import Select from "react-select";
import { Countries } from "../../../../api/CountryApi";
import { getallLang } from "../../../../api/LanguageApi/Lang";

const UpdateNew = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const alert = useAlert();
  const [productLocation, setProductLocation] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [imgs, setImgs] = useState([]);
  const [existingImg, setExistingImg] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [archived, setArchived] = useState("");
  const [massage, setMassage] = useState("");

  useEffect(() => {
    dispatch(getNewById(id));
  }, [dispatch]);
  const data = useSelector((state) => state.news.new);
  // console.log(data);
  useEffect(() => {
    if (data) {
      const item = Array.isArray(data) ? data[0] : data;
      setTitle(item?.title || "");
      setContent(item?.content || "");
      setArchived(item?.archieved ? 1 : 0);
      setExistingImg(item?.image || "");
      setSelectedOption({ value: item?.lang?.id, label: item?.lang?.name });
      const match = Countries.find(
        (c) => c.code === item?.location || c.name === item?.location
      );
      setProductLocation(
        match ? { value: match.code, label: match.name } : { value: item?.location, label: item?.location }
      );
    }
  }, [data]);
  const handleSumbit = (e) => {
    e.preventDefault();
    let payload = null;
    if (imgs.length > 0) {
      const fd = new FormData();
      fd.append("title", title || "");
      fd.append("content", content || "");
      fd.append("archieved", archived);
      if (selectedOption?.value) fd.append("language_id", selectedOption.value);
      if (productLocation?.value) fd.append("location", productLocation.value);
      imgs.forEach((file) => fd.append("image[]", file, file.name));
      payload = fd;
    } else {
      payload = {
        title: title,
        image: existingImg || "",
        content: content,
        archieved: archived,
        language_id: selectedOption?.value,
        location: productLocation?.value,
      };
    }
    dispatch(UpdateNewApi({ id: id, newData: payload }))
      .unwrap()
      .then((originalPromiseResult) => {
        // handle result here
        alert.show("Sucessful Updated");
        // optionally refresh list
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
        alert.show(rejectedValueOrSerializedError?.response?.data?.message);

        // alert(rejectedValueOrSerializedError.response.data.message);
        console.log(rejectedValueOrSerializedError);
      });
  };
  const langs = useSelector((state) => state?.Lang?.lang?.langs);
  const options = langs?.map((language) => ({
    value: language.id,
    label: language.name,
  }));
  const optionsCoun = Countries?.map((item) => ({
    value: item.code,
    label: item.name,
  }));
  useEffect(() => {
    dispatch(getallLang());
  }, [dispatch]);

  return (
    <div className="newContainer">
      <SideBar />
      <div className="NewWrapper">
        <Header title={"Add News"} />
        <div className="newBody">
          <form action="" className="addNewForm" onSubmit={handleSumbit}>
            <h1>Update News</h1>
            <div style={{ width: "20vw" }}>
              <p>Language</p>
              <Select value={selectedOption} onChange={setSelectedOption} options={options} />
            </div>
            <div style={{ width: "20vw" }}>
              <p>Country</p>
              <Select value={productLocation} onChange={setProductLocation} options={optionsCoun} />
            </div>
            <div className="newInputFile">
              <input
                type="file"
                name="image"
                id=""
                multiple
                onChange={(e) => {
                  setImgs(Array.from(e.target.files));
                }}
              />
              <small style={{ color: "#666", marginTop: "4px" }}>{imgs.length} new image(s) selected</small>
              {!imgs.length && existingImg && (
                <small style={{ color: "#666", marginTop: "4px" }}>Keeping existing image</small>
              )}
            </div>
            <div className="newInput">
              <span>title</span>
              <input
                type="text"
                placeholder="name@example"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="newInput">
              <span>Content</span>
              <input
                className="contentNew"
                type="text"
                value={content}
                placeholder="Add Content"
                onChange={(e) => setContent(e.target.value)}
              />
            </div>
            <div className="newCheckBox">
              <input type="checkbox" checked={!!archived} onChange={() => setArchived(archived ? 0 : 1)} />
              <span>Archived</span>
            </div>
            <button className="buttonSave">Save</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateNew;
